import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CONTENT_WIDTH, Divider, MainContentBox } from 'enova-frontend-components';

import { SessionExpiresDialog } from '../../components/sessionExpiresDialog';
import {
  MainContentWrapper,
  SidebarPageLayout,
  SidebarWrapper
} from '../registrationV2025/components/styledComponents';
import styled from '../../styled';

import { MainMenu } from './mainMenu';
import { EFCMenu } from './mainMenu/efcMenu';

const MainLayoutWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  width: 100%;
`;

const isBalderDesign = window.config.VITE_BALDER_DESIGN_ENABLED;

const MainScreenLayout = () => {
  if (!isBalderDesign) {
    // TODO: Remove with feature flag
    return (
      <MainLayoutWrapper id="main-screen-layout">
        <EFCMenu maxWidth={CONTENT_WIDTH.xs} />

        <Box width="100%" display="block">
          <Divider />
        </Box>

        <MainContentBox pt={0} maxWidth={CONTENT_WIDTH.xs}>
          <Outlet />
        </MainContentBox>

        <SessionExpiresDialog />
      </MainLayoutWrapper>
    );
  }

  return (
    <SidebarPageLayout style={{ margin: 'var(--ds-size-22) auto' }}>
      <SidebarWrapper>
        <MainMenu />
      </SidebarWrapper>

      <MainContentWrapper>
        <Outlet />
      </MainContentWrapper>

      <SessionExpiresDialog />
    </SidebarPageLayout>
  );
};

export default MainScreenLayout;
